export const AUTH_TOKEN = 'AUTH_TOKEN'
export const SERVICE_INFO = 'SERVICE_INFO'
export const DYNAMIC_PRICE = 'DYNAMIC_PRICE'
export const GOA_PRICE = 'GOA_PRICE'
export const PRICE = 'PRICE'
